import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { listingsApi as n } from "@maat/api-main";
//#region src/properties/useListingSiblingsQuery.ts
var r = (r, i) => t({
	queryKey: e.siblings(r, i),
	queryFn: () => n.getListingSiblings(r, i),
	enabled: !!r,
	retry: !1,
	placeholderData: (e) => e
});
//#endregion
export { r as useListingSiblingsQuery };
